var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showRecommendedLess
    ? _c(
        "div",
        {
          staticClass: "text-center",
          attrs: { "data-test": "recommended-less" },
        },
        [
          _c("div", [
            _vm._v(
              "「本日のおすすめ」は、各求人のマッチング条件と女の転職type会員の行動をもとにした、貴社へのスカウトおすすめ会員です。"
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "表示されない場合は、マッチング条件の変更などを制作担当者へご相談ください。"
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }